import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    url: String,
  };

  connect() {
    // Trigger the download as soon as the controller connects
    if (this.hasUrlValue) {
      this.triggerDownload();
    }
  }

  triggerDownload() {
    // Create a hidden link and click it programmatically
    const link = document.createElement('a');
    link.href = this.urlValue;
    link.style.display = 'none';
    link.setAttribute('download', '');
    document.body.appendChild(link);
    link.click();

    // Remove the link after a short delay
    setTimeout(() => {
      document.body.removeChild(link);
    }, 100);

    setTimeout(() => {
      window.location.reload();
    }, 1500);
  }
}
